import React from "react";
import PageNavigationItem from "./PageNavigationItem";
import logo from "../../global/img/dol/logo-blue.svg";
import classNames from "classnames";
import { useRecoilValue } from "recoil";
import {
  tablePageErrorSelector_9142B_9089,
  tablePageErrorSelector_9142C,
} from "../SimpleForm/Atoms/Table/selectors";
import { useSaveForm } from "../Hooks";

function PageNavigation({
  activePage,
  setPage,
  summary_loading,
  setSummaryLoading,
  goSummaryPage,
  uiSchema_meta,
  uiSchema_nav,
  pages_errors,
  pages_visited,
  keyboardFocusProps,
  formSaveMutation,
  formSaveMutationCallback,
  values,
  form_ui,
  tablePagesErrors,
}) {
  const tablePageErrors_1 = useRecoilValue(tablePageErrorSelector_9142B_9089);
  const tablePageErrors_2 = useRecoilValue(tablePageErrorSelector_9142C);

  const saveForm = useSaveForm({
    formSaveMutation,
    formSaveMutationCallback,
    formValues: values,
    form_ui,
    tablePagesErrors,
    delay: 1000,
  });

  const renderPageList = () => (
    <ul className={"form-nav-list"}>
      {uiSchema_nav.map((page, index) => {
        let page_visited = pages_visited.indexOf(index) > -1;
        let page_errored = pages_errors.indexOf(index) > -1;

        let stepper_error = page_errored && page_visited;
        let stepper_complete = !page_errored && page_visited;
        const pageHasTableError_1 = tablePageErrors_1.includes(index);
        const pageHasTableError_2 = tablePageErrors_2.includes(index);

        if (pageHasTableError_1 || pageHasTableError_2) {
          stepper_error = true;
        }
        return (
          <PageNavigationItem
            handlePageChange={() => {
              setPage(index);
              document.getElementsByClassName(
                "ReactModal__Content--after-open"
              )[0].scrollTop = 0;
              saveForm();
            }}
            active={index === activePage}
            error={stepper_error}
            complete={stepper_complete}
            name={page.name}
            prefix={page.prefix || undefined}
            symbol={page.symbol || undefined}
            classes={page.classes || undefined}
            key={index}
            // Make forms keyboard navigable
            keyboardFocusProps={keyboardFocusProps}
          />
        );
      })}

      <PageNavigationItem
        handlePageChange={() => {
          setSummaryLoading(true);
          setTimeout(goSummaryPage, 1);
          saveForm();
        }}
        active={uiSchema_nav.length === activePage}
        error={false}
        complete={false}
        name={"Review & Submit"}
        symbol={summary_loading ? "loader" : "document"}
        // Make forms keyboard navigable
        keyboardFocusProps={keyboardFocusProps}
      />
    </ul>
  );

  let formRowClasses = classNames(
    "form-sidebar",
    "mobile:grid-col-12",
    "tablet:grid-col-3",
    {}
  );

  return (
    <div className={formRowClasses}>
      <div className="grid-container form-nav">
        <div className="grid-row flex-row flex-align-center form-nav-header">
          <div className="seal-column grid-col-2">
            <img
              className="seal"
              src={logo}
              alt="U.S. Department of Labor Seal"
            />
          </div>
          <div className="grid-col-10 form-nav-header--form-type">
            <span className="form-machine-name">{uiSchema_meta.code}</span>
            <h2 className="form-name">{uiSchema_meta.name}</h2>
            {!!uiSchema_meta?.version && (
              <span className="form-machine-name">
                {uiSchema_meta?.version}
              </span>
            )}
          </div>
        </div>
        {renderPageList()}
      </div>
    </div>
  );
}
export default PageNavigation;
